import React, { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import { ButtonHeading } from "components";
import "../Fastags/Fastags.css";
import { constant } from 'constants/constant';
import Tab from "components/common/Tab";
import DebitTab from "../Tabs/DebitTab";
import { getfastagDetailsApi } from "_services";
import { StorageServices } from "utils";
import moment from "moment";
import useDocumentTitle from "hooks/useDocumentTitle";

const FastagDetails = () => {
    let { id } = useParams();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const tabFromQuery = parseInt(queryParams.get('tab')) || 1;
   
      useDocumentTitle("Fastag Details | T360");
    const [activeTab, setActiveTab] = useState(tabFromQuery);
    const [activeTransactionTab, setActiveTransactionTab] = useState(0);
    const companyId = StorageServices.getCompanyId();
    const [fastagDetails, setFastagDetails] = useState({});
    const [loading, setLoading] = useState(false);
    
    const [selectedRange, setSelectedRange] = useState({
        startDate: "",
        endDate: "",
    });

    const [filter, setFilter] = useState({
        start_date: "",
        end_date: "",
        search: "",
        limit: 25,
        offset: 1,
        txntype: "",
        trip_relation:0
    });

    const fastagDetailsHandle = async (fastagId) => {
        setLoading(true);
        
        const payload = {
            company_id: companyId,
            fastag_number: fastagId ,
            start_date: filter.start_date,
            end_date: filter.end_date,
            // start_date:"",
            // end_date:"",
            search: filter.search,
            limit: filter.limit,
            offset: filter.offset,
            txntype: activeTab==2?"D":activeTab==3?"C":"",
            trip_relation:filter?.trip_relation
        };

        try {
            const res = await getfastagDetailsApi(payload);
            if (res?.responseCode === 200) {
                setFastagDetails(res?.data);
            }
        } catch (error) {
            console.error("Error fetching fastag details:", error);
        } finally {
            setLoading(false);
        }
    };

    const tabProps = {
        tabList: constant.fastDetailsTabs,
        activeTab: activeTab,
        callBackTab: (e) => {
            setActiveTab(e);
        },
    };

    // Handle status change
    const handleStatusChange = async () => {
          fastagDetailsHandle(id);
    };

    const DebitTabprops = {
        fastagDetails,
        filter,
        setFilter,
        setSelectedRange,
        selectedRange,
        loading,
        activeTransactionTab,
        setActiveTransactionTab,
         onStatusChange: handleStatusChange
    };

    useEffect(() => {
        if (id) {
            fastagDetailsHandle(id);
        }
    }, [id, filter.start_date, filter.end_date, filter.search, filter.offset, activeTab,filter?.trip_relation]);

    return (
        <>
            <ButtonHeading title="Fastag Details" />
            
            {/* FasTag Details Card */}

            <div className='addPr_flBx __sulpFlx_main'>
            <div className='fastag-details-card' style={{
                background: '#fff',
                padding: '10px 20px 1px 20px',
                marginBottom: '8px',
                borderRadius: '8px',
                boxShadow: '0 1px 1px rgba(0,0,0,0.1)'
            }}>
                <div style={{ marginBottom: '16px' }}>
                    {fastagDetails?.fastag?.assigned_to_vehicle?.vehicle_no && <h3 style={{
                        fontSize: '18px',
                        fontWeight: '500',
                        marginBottom: '4px',
                        color: '#001B50'
                    }}>
                        {fastagDetails?.fastag?.assigned_to_vehicle?.vehicle_no }
                    </h3>}
                    <p style={{
                        fontSize: '14px',
                        color: '#001B50',
                        margin: 0
                    }}>
                        Fastag ID {fastagDetails?.fastag?.fastag_number || '3495783457837457'}
                    </p>
                </div>
            </div>
                <span style={{
                        fontSize: '14px',
                        color: '#001B50',
                        padding:'0px 20px'
                    }}>
                      Transactions
                    </span>
                <Tab {...tabProps} />
                {activeTab === 1 && <DebitTab {...DebitTabprops} />}
                {activeTab === 2 && <DebitTab {...DebitTabprops} />}
                {activeTab === 3 && <DebitTab {...DebitTabprops} />}
            </div>
        </>
    );
};

export default FastagDetails;